import { api } from './client';
import type { SelectedPaczkomat } from '../util/paczkomat';

export type { SelectedPaczkomat };

export const searchPaczkomats = (q: string, signal?: AbortSignal) =>
  fetch(`/api/paczkomats?q=${encodeURIComponent(q)}`, { signal }).then(async (res) => {
    if (!res.ok) {
      const err = new Error(`paczkomat search failed: ${res.status}`) as Error & {
        status?: number;
      };
      err.status = res.status;
      throw err;
    }
    return (await res.json()) as { items: SelectedPaczkomat[] };
  });

export const getPaczkomat = (code: string) =>
  api.get<SelectedPaczkomat>(`/paczkomats/${encodeURIComponent(code)}`);

export const getGeowidgetToken = () =>
  api.get<{ token: string }>('/paczkomats/geowidget-token');
